import {
  Box,
  ClickAwayListener,
  IconButton,
  Popper,
  Typography,
  useTheme,
} from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../api/useFetch';
import { NewLeadStatus } from './NewLeadStatus';
import { useEffect, useState } from 'react';
import { updateOrCreate } from '../../../components/special/updateOrCreate';
import { Status } from '../../../components/special/Status';
import EditIcon from '@mui/icons-material/Edit';
import { StatusEditor } from './StatusEditor';
import { API_GET, DBRequest, useConfig } from '../../../api/api';

export const LeadStatusSelector = ({
  anchorEl,
  onClose,
  onStatusChange,
  customStatuses,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const [apiData, setApiData] = useState({});
  //const { apiData, setApiData } = useFetch('lead-statuses');
  const [openEditor, setOpenEditor] = useState(false);

  useEffect(() => {
    if (customStatuses) {
      setApiData({ data: customStatuses });
    } else {
      if (!config) return;
      DBRequest({
        config,
        path: `lead-statuses`,
        method: API_GET,
        onResponse: setApiData,
      });
    }
  }, [config]);

  function handleStatusData(data) {
    setApiData(updateOrCreate(apiData, data.data));
  }

  function handleStatusChange(status) {
    onStatusChange(status);
    onClose();
  }
  function handleDeletedStatus(status) {
    const newStatuses = apiData?.data.filter((obj) => obj.id !== status.id);
    setApiData({ ...apiData, data: newStatuses });
  }

  const open = Boolean(anchorEl);
  return (
    <>
      <Popper anchorEl={anchorEl} open={open} placement="bottom-start">
        <ClickAwayListener onClickAway={onClose}>
          <Box
            className="px-3 py-1 rounded-lg flex flex-col gap-1 relative"
            sx={{
              background: `linear-gradient(135deg,  ${colors.glassFrom}, ${colors.glassTo})`,
              border: `1px solid ${colors.selected}`,
              backdropFilter: `blur(5px)`,
            }}
          >
            <Box className="flex justify-between">
              <Typography variant="h6">{t('Change Status')}</Typography>
              {!customStatuses && (
                <IconButton size="small" onClick={() => setOpenEditor(true)}>
                  <EditIcon sx={{ fontSize: 14 }} />
                </IconButton>
              )}
            </Box>

            <Box className="flex flex-col gap-1 pb-3">
              {apiData &&
                apiData.data &&
                apiData.data.length > 0 &&
                apiData?.data.map((status) => (
                  <Status
                    key={status.id}
                    text={status.label}
                    variant={status.variant}
                    statusColor={status.color}
                    onClick={() => handleStatusChange(status)}
                  />
                ))}
            </Box>
          </Box>
        </ClickAwayListener>
      </Popper>
      <StatusEditor
        open={openEditor}
        statuses={apiData?.data}
        onCreate={handleStatusData}
        onUpdate={handleStatusData}
        onClose={() => setOpenEditor(false)}
        onDelete={handleDeletedStatus}
      />
    </>
  );
};
